module.exports = __webpack_public_path__ + "static/media/cardConsole.fde841ac.png";